export default __webpack_public_path__ + "static/media/NotoSans.fa11626f.ttf";